import React, { useState } from "react";
import { Button, Col, Form, FormGroup, Input, Label, Row, Spinner } from "reactstrap";
import { AUTOPILOT_COLORS } from "../../../components/autopilot/styles";
import { useToast } from "../../../hooks/toast";
import { salvarContatoTi } from "../../../services/habilitacaoApi";

// Formulário curto do contato de TI (PO1-3106, kickoff pergunta 2): nome,
// e-mail e telefone, pré-preenchido com quem aceitou o convite. Grava o
// contato de TI da transportadora com o embarcador do vínculo.
export default function ContatoTiForm({ idVinculo, embarcadorNome, sugestao, contatoAtual, onSalvo }) {
  const { addToast } = useToast();
  const inicial = contatoAtual || sugestao || {};
  const [nome, setNome] = useState(inicial.nome || "");
  const [email, setEmail] = useState(inicial.email || "");
  const [ddd, setDdd] = useState("");
  const [telefone, setTelefone] = useState("");
  const [salvando, setSalvando] = useState(false);

  const salvar = async (event) => {
    event.preventDefault();
    setSalvando(true);
    try {
      const out = await salvarContatoTi(idVinculo, { nome: nome.trim(), email: email.trim(), ddd, telefone });
      addToast({ place: "tr", type: "success", title: "Contato de TI salvo", description: `Contato gravado para ${embarcadorNome}.` });
      if (onSalvo) onSalvo(out);
    } catch (e) {
      const data = (e && e.response && e.response.data) || {};
      addToast({ place: "tr", type: "danger", title: "Não foi possível salvar", description: data.error || "Falha ao salvar o contato." });
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Form onSubmit={salvar} style={{ marginTop: "0.6rem" }}>
      <Row form>
        <Col md={5}>
          <FormGroup className="mb-2">
            <Label style={{ color: AUTOPILOT_COLORS.muted, fontSize: "0.76rem" }}>Nome *</Label>
            <Input bsSize="sm" value={nome} onChange={(e) => setNome(e.target.value)} maxLength={60} required />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup className="mb-2">
            <Label style={{ color: AUTOPILOT_COLORS.muted, fontSize: "0.76rem" }}>E-mail *</Label>
            <Input bsSize="sm" type="email" value={email} onChange={(e) => setEmail(e.target.value)} maxLength={100} required />
          </FormGroup>
        </Col>
        <Col md={1}>
          <FormGroup className="mb-2">
            <Label style={{ color: AUTOPILOT_COLORS.muted, fontSize: "0.76rem" }}>DDD</Label>
            <Input bsSize="sm" value={ddd} onChange={(e) => setDdd(e.target.value.replace(/\D/g, "").slice(0, 4))} inputMode="numeric" />
          </FormGroup>
        </Col>
        <Col md={2}>
          <FormGroup className="mb-2">
            <Label style={{ color: AUTOPILOT_COLORS.muted, fontSize: "0.76rem" }}>Telefone</Label>
            <Input bsSize="sm" value={telefone} onChange={(e) => setTelefone(e.target.value.replace(/\D/g, "").slice(0, 20))} inputMode="numeric" />
          </FormGroup>
        </Col>
      </Row>
      <Button color="primary" size="sm" type="submit" disabled={salvando}>
        {salvando ? <Spinner size="sm" /> : contatoAtual ? "Atualizar contato de TI" : "Salvar contato de TI"}
      </Button>
    </Form>
  );
}
